<button mat-icon-button class="close-button" [mat-dialog-close]="true" >
    <mat-icon class="close-icon">close</mat-icon>
</button>
<img src="../../../assets/images/check-green.gif">
<div class="text-align">
    <h1 style="color: rgb(3, 207, 3);">Refund request created successfully</h1>
    <span class="shown_name"></span> Refund requested for the transaction reference number
    <b>{{data.data.AFSTransactionId}}</b> and
    your refund request number is <b>{{data.response}}</b>. Please note it for the future use.
</div>
<button mat-raised-button class="create" (click)="onNoClick()" style="float: right; margin-top: 40px;">
    <span class="material-symbols-outlined">
        restart_alt
    </span> Track your refund
</button>